import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom"; // Import Link from react-router-dom
import { AppBar, Container, Typography } from "@mui/material";
import { IoMdHome } from "react-icons/io";
import { BsQrCode } from "react-icons/bs";
import { IoDocumentText } from "react-icons/io5";
import { LuCalendarSearch } from "react-icons/lu";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import TopicOutlinedIcon from "@mui/icons-material/TopicOutlined";
import "./footer.css";
import { Button } from "react-bootstrap";

const Footer = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const location = useLocation(); // Get current location

  // Helper function to check if a page is active
  const isActive = (path) => location.pathname === path;

  return (
    <React.Fragment>
      <footer className="mfooter">
        <div
          className={`mfooter-item ${isActive("/dashboard") ? "active" : ""}`}
          onClick={() => navigate("/dashboard")}
        >
          <IoMdHome className="img" />
          <span>Home</span>
        </div>
        <div
          className={`mfooter-item ${isActive("/my_event") ? "active" : ""}`}
          onClick={() => navigate("/my_event")}
        >
          <BsQrCode className="img" />
          <span>My Event</span>
        </div>
        <div
          className={`mfooter-item ${
            isActive("/discover_event") ? "active" : ""
          }`}
          onClick={() => navigate("/discover_event")}
        >
          <LuCalendarSearch className="img" />
          <span>Discover</span>
        </div>
        <div
          className={`mfooter-item ${isActive("/gallery") ? "active" : ""}`}
          onClick={() => navigate("/gallery")}
        >
          <PhotoLibraryOutlinedIcon className="img" />
          <span>Gallery</span>
        </div>
        <div
          className={`mfooter-item ${isActive("/document") ? "active" : ""}`}
          onClick={() => navigate("/document")}
        >
          <TopicOutlinedIcon className="img" />
          <span>Documents</span>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
